export default __webpack_public_path__ + "static/media/NunitoSans-Regular.5091590c.woff2";